import React, { useEffect, useState } from "react";

const RoleRegistrationsForm = ({ onCreateRole }) => {
  const [roleName, setRoleName] = useState("");
  const [dealerCode, setDealerCode] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [toastState, setToastState] = useState({
    show: false,
    type: "success",
    message: "",
  });

  const rolesEndpoint = `${process.env.REACT_APP_SERVER_URL}/aipd/role-management/roles`;

  const passtoken =
    !localStorage.getItem("access-token-storage") ||
    localStorage.getItem("access-token-storage") === null
      ? null
      : JSON.parse(localStorage.getItem("access-token-storage"))["accessToken"];

  const showToast = (message, type = "success") => {
    setToastState({
      show: true,
      type,
      message,
    });
  };

  useEffect(() => {
    if (!toastState.show) {
      return undefined;
    }

    const timer = setTimeout(() => {
      setToastState((prevState) => ({ ...prevState, show: false }));
    }, 3000);

    return () => clearTimeout(timer);
  }, [toastState.show]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const trimmedRole = roleName.trim();
    const trimmedDealerCode = dealerCode.trim();
    if (!trimmedRole) {
      showToast("Role Name cannot be empty.", "danger");
      return;
    }

    if (!trimmedDealerCode) {
      showToast("Dealer Code cannot be empty.", "danger");
      return;
    }

    setIsSubmitting(true);

    try {
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };

      if (passtoken) {
        headers["oidc-token"] = passtoken;
      }

      const response = await fetch(rolesEndpoint, {
        method: "POST",
        headers,
        body: JSON.stringify({
          roleName: trimmedRole,
          dealerCode: trimmedDealerCode,
        }),
      });

      const responseJson = await response.json().catch(() => null);

      if (!response.ok) {
        throw new Error(responseJson?.message || "Failed to create role.");
      }

      if (onCreateRole) {
        onCreateRole(trimmedRole, trimmedDealerCode);
      }
      setRoleName("");
      setDealerCode("");
      showToast("Role created successfully.", "success");
    } catch (error) {
      showToast(error?.message || "Unable to create role at the moment.", "danger");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="rr-wrap container-fluid pb-4">
      {toastState.show && (
        <div
          style={{
            position: "fixed",
            top: "16px",
            right: "16px",
            zIndex: 99999,
            minWidth: "320px",
            maxWidth: "420px",
          }}
        >
          <div className={`alert alert-${toastState.type} shadow-sm mb-0`} role="alert">
            {toastState.message}
          </div>
        </div>
      )}

      <div className="rr-card">
        <div className="rr-cardHeader">
          <p className="rr-kicker">Role Intake</p>
          <h5 className="rr-title">Role Registration</h5>
          <p className="rr-subtitle">Create a new role by entering role name.</p>
        </div>

        <div className="rr-content">
          <div className="rr-attentionNote" role="note" aria-live="polite">
            Please add the exact Role Name and Dealer Code here as it was mentioned in the AAS.
          </div>

          <div className="rr-sidePanel">
            <div className="rr-sideBadge">Info</div>
            <ul className="rr-checklist">
              <li>Use a clear and unique role name.</li>
              <li>Role names are checked for duplicates.</li>
            </ul>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="row g-3 rr-formGrid">
              <div className="col-12 col-md-6">
                <label htmlFor="roleName" className="form-label rr-label">
                  Role Name
                  <span className="text-danger ms-1">*</span>
                </label>
                <input
                  id="roleName"
                  name="roleName"
                  type="text"
                  className="form-control rr-input"
                  placeholder="Enter role name"
                  value={roleName}
                  onChange={(event) => setRoleName(event.target.value)}
                  disabled={isSubmitting}
                  required
                />
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="dealerCode" className="form-label rr-label">
                  Dealer Code
                  <span className="text-danger ms-1">*</span>
                </label>
                <input
                  id="dealerCode"
                  name="dealerCode"
                  type="text"
                  className="form-control rr-input"
                  placeholder="Enter dealer code"
                  value={dealerCode}
                  onChange={(event) => setDealerCode(event.target.value)}
                  disabled={isSubmitting}
                  required
                />
              </div>
            </div>

            <div className="d-flex gap-2 mt-4 rr-actions">
              <button type="submit" className="btn rr-btnPrimary" disabled={isSubmitting}>
                {isSubmitting ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Creating...
                  </>
                ) : (
                  "Create Role"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RoleRegistrationsForm;
